/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';

import ConfirmationModal from './ConfirmationModal';

import Content from 'services/Content';

import { openEducationAuthTab } from 'services/ExternalAuthorizationURLBuilder';

const ExternalLinkModal = ({ isAlaska529, ...props }) => (
  <ConfirmationModal
    modalClassname={`external-link-modal ${isAlaska529 ? 'alaska' : ''}`}
    title="You are being redirected to an external link"
    content={
      isAlaska529 ? Content.externalLinkAlaska : Content.externalLinkNational
    }
    onConfirm={() => openEducationAuthTab(isAlaska529)}
    {...props}
  />
);

export default ExternalLinkModal;
